// import * as addToBagConfig from '@nuxt-common/add-to-bag/config.bcom';
// export * from './app/config/baby-registry-bcom';

import { links as LeftNav } from '@nuxt-common/left-nav/config.bcom.js';
export * from '@nuxt-common/payment-cards/config.bcom.js';
export * from '@nuxt-common/login-component/config.bcom.js';

export const brand = 'bcom';
export const brandName = 'Bloomingdale’s';

export const links = LeftNav;

export const separateEntity = {
  SE_MATCH: () =>
    "We recently mailed a replacement Macy's Credit Card for each user of this account to the primary card holder. Your Wallet was automatically updated with your replacement card number.",
  SE_MISMATCH_MPAY: (preDuality) =>
    preDuality
      ? 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You\'ll need to add your replacement card to your Wallet and Macy\'s Pay. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>'
      : 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You need to add your replacement card to your Wallet and Macy\'s Pay as your old card is no longer valid. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>',
  SE_MISMATCH: (preDuality) =>
    preDuality
      ? 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You\'ll need to add your replacement card to your Wallet. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>'
      : 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You need to add your replacement card to your Wallet as your old card is no longer valid. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>',
};

export const offerNotifications = {
  success: 'Changes saved to your wallet.',
  invalidCode: 'The promo code you entered is invalid. Please try again or call Customer Service at 1-800-777-0000.',
  alreadyInWallet: 'THIS OFFER IS ALREADY IN YOUR bWALLET AND CAN BE APPLIED AT CHECKOUT.',
};

export const genericErrorMessages = {
  unavailable: "We're sorry, but we cannot display your information at this time.",
};

export const WALLET = {
  defaultLabel: 'Default',
  menuLabel: 'My bWallet',
  setDefaultBtn: 'Set as default',
  pageTitle: 'Payment Methods',
  beautyBoxMsg: 'Subscribed to Beauty Box',
  editLabel: 'Edit',
  okayLabel: 'Okay',
  setCardLabel: 'Set Up Card',
  makePaymentLabel: 'Make a Payment',
  addPaymentLabel: 'Add A Payment Method',
  addPaymentMethodMsg: `You don't have any saved payment methods. Add a payment method to checkout faster.`,
  setCardMsg: `You'll need to set up your card to pay your bill and manage this card online.`,
  setCardError: 'We’re unable to add your card. Please try again later.',
  amexCardDescription: `American Express is a federally registered service mark of American Express and is used by Citibank, N.A. pursuant to a license. The Macy’s
          American Express Card program is issued and administered by Citibank, N.A.`,
  macysAmexCardNotification: `We recently notified you that your Macy’s American Express® Account is being closed. Your store account remains open.
                  We’ve automatically updated the credit card number in your Wallet to reflect the credit card number for your store account.
                  If you have any questions, please call 1-866-593-2543 for assistance.`,
};
